import React, { useState, useEffect } from 'react';
import { Modal, Button, FormGroup, Col, ControlLabel } from 'react-bootstrap';
import YesNoUnknown from './yes-no-unknown';

interface IAlertProps {
    show: boolean;
    onConfirm: () => void;
    onClose: () => void;
}

const CreatinineAlert = (props: IAlertProps) => {
    const [isConfirmed, setIsConfirmed] = useState<boolean | null>(null);

    // Reset state each time modal opens
    useEffect(() => {
        if (props.show) {
            setIsConfirmed(null);
        }
    }, [props.show]);


    const handleChange = (_name: string, value: boolean | null) => {
        setIsConfirmed(value);
    };


    const handleConfirmClick = () => {
        if (isConfirmed == true) {
            props.onConfirm();
        } else if (isConfirmed == false) {
            props.onClose();
        }
    };

    return (
        <Modal show={props.show} onHide={props.onClose} bsSize='medium' backdrop='static'>
            <Modal.Header closeButton>
                <Modal.Title>
                    <div style={{ color: '#c9372e', fontWeight: 'bold' }}>ALERT</div>
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div style={{
                    color: '#c9372e',
                    fontWeight: 'bold',
                    marginBottom: 20,
                    textAlign: 'center'
                }}>
                    Very few donors have a creatinine clearance below 80 or above 180.<br />
                    Can you please confirm that the entered value is accurate?
                </div>

                <FormGroup>
                    <Col xs={12} lg={5} componentClass={ControlLabel}>
                        Confirm Value
                    </Col>
                    <Col xs={12} lg={7}>
                        <YesNoUnknown
                            name='isCreatinineConfirmed'
                            yes={isConfirmed == true}
                            no={isConfirmed == false}
                            onChange={handleChange}
                        />
                    </Col>
                </FormGroup>
            </Modal.Body>

            <Modal.Footer>
                <Button bsStyle='default' onClick={props.onClose}>
                    Cancel
                </Button>

                <Button
                    bsStyle='danger'
                    onClick={handleConfirmClick}
                    disabled={isConfirmed == null}
                >
                    Confirm
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default CreatinineAlert;